export enum EntityType {
  Athlete = 'IND',
  Team = 'EQU',
  Group = 'ENS',
  MF = 'EQU_ENS'
}
